import styled from 'styled-components';
import { Link } from 'react-router-dom';
export const SampleProofSection = styled.div``

export const SectionTitle = styled.h3`
    padding: 0 calc(100vw*(20/375));
    font-size: calc(100vw*(18/375));
    font-weight: bold;
    line-height: 1.11;
    margin-bottom: calc(100vw * (18 / 375));
`

export const TextBox = styled.div`
    width: 100%; 
    height: auto;
    border-radius: calc(100vw*(5/375));
    margin-bottom: calc(100vw * (34 / 375)); 
`
export const ProofList = styled.div`  
    display: flex; 
    flex-wrap: nowrap; 
    overflow-x: auto;  
    padding : 0 calc(100vw*(13/375));
    &::-webkit-scrollbar {
        display: none;
    }
`   
export const ImgWrapper = styled.div`   
    ${(props)=>(props['width'])?`width : ${props['width']};`:'width : 43%;'};
    flex: 0 0 auto;
    padding : 0 calc(100vw*(7/375));
`  
export const SampleProofImg = styled.img`
    width : 100%;
    height: 100%;
    object-fit: cover;
    image-rendering: -moz-crisp-edges;         /* Firefox */
    image-rendering:   -o-crisp-edges;         /* Opera */
    image-rendering: -webkit-optimize-contrast;/* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;  /* IE (non-standard property) */
`;


export const TodolistBtnWrapper = styled.div`
    padding : 0 calc(100vw * (25 / 375));
`
export const TodolistBtn = styled(Link)`
    display:inline-block;
    background-color: #FFCF19;;
    border-radius:5px;
    width: 100%;
    height: calc(100vw * (56 / 375));
    line-height:calc(100vw * (56 / 375));
    text-align: center;
`
export const TodolistBtnTxt = styled.span`
    color: #121212;
    font-size: calc(100vw*(16/375));
    font-weight: 700;
` 
export const GreyTodolistBtn = styled.div`
    display:inline-block;
    background-color: #EDEDED;
    border-radius:5px;
    width: 100%;
    height: calc(100vw * (56 / 375));
    line-height:calc(100vw * (56 / 375));
    text-align: center;
`
export const GreyTodolistBtnTxt = styled.span`
    color: #C7C8CA;
    font-size: calc(100vw*(16/375));
    font-weight: 700;
`